module.exports = __webpack_public_path__ + "static/media/KRA.3b01acd6.png";